import http, { apiErrorMessage } from '../../http';

export const get = (id) => {
    return (dispatch, getState) => {
        http.get('version')
            .then(function (response) {
                // Envelope v1: {data:{id,version}}
                dispatch({
                    type: "VERSION_GET", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'VERSION_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            });
    }
}

export const closeMessages = () => {
    return (dispatch, getState) => {
        dispatch({type: "VERSION_CLOSE_MESSAGES"});
    }
}
